import { ContainerModel } from './server/container-model';

export interface Container {
    name: string;
    number: number;
}

export function mapModelToContainer(model: ContainerModel): Container {
    return {
        number: model.number,
        name: model.shortName?.trim() || model.name?.trim() || model.number.toString(),
    };
}
